import React from 'react';
import { Col, Row, Spinner } from 'react-bootstrap';
import Moment from 'react-moment';

type CheckinSiteInfoProps = {
    siteName?: string,
    checkinTime?: string,
    duration?: string
}

export const CheckinSiteInfo = ({siteName, checkinTime, duration}: CheckinSiteInfoProps) => {
    return (
        <Row className="mb-3">
            <Col>
                <Row className="grouped py-3 mx-1 summary-block">
                    <Col>
                        <Row>
                            <Col className="med-heading">
                                <b>{siteName}</b>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mb-1 sub-heading">
                                Check in at {checkinTime && <Moment format="DD MMM YYYY, hh:mm a">{checkinTime}</Moment>}
                            </Col>
                        </Row>
                        <Row>
                            <Col className="sub-heading">
                                <strong>
                                    {duration ? duration : <Spinner animation="border" size="sm"/>}
                                </strong>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}
